import React, { useState } from 'react';

import { cn, mString, toNegative } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

import SummaryItem from './SummaryItem';

const AdjustmentsAndDiscounts = ({
  discount,
  writeOffs,
  otherAdjustments,
  insuranceAdjustments,
  insuranceBalance,
  preview,
  isAEOB,
  estimatedLabel
}) => {
  const [open, setOpen] = useState(preview);

  return (
    <div className="mt-5 flex flex-col gap-5 pl-2 sm:mt-2 sm:gap-2">
      <div className="flex w-full items-center justify-between">
        <Button
          variant="link"
          text={`Adjustments and discounts${estimatedLabel}`}
          color="neutral"
          size="xs"
          iconColor="neutral-700"
          iconRight={!preview && 'chevron-down-linear'}
          iconClassName={cn('transition-transform duration-300', open && 'rotate-180')}
          shade={600}
          textClassName="text-sm leading-[114%] font-medium normal-case text-neutral-600"
          isDisabled={preview}
          onClick={() => setOpen((prev) => !prev)}
        />
        <Typography variant="label" size="medium">
          {mString(
            toNegative(
              discount + writeOffs + otherAdjustments + insuranceAdjustments + insuranceBalance
            )
          )}
        </Typography>
      </div>
      <div
        className={cn(
          'flex w-full flex-col gap-5 overflow-hidden pl-6 transition-all duration-300 sm:gap-2 sm:pl-2',
          open ? 'mb-5 max-h-40 opacity-100 sm:mb-2' : 'pointer-events-none mt-0 max-h-0 opacity-0'
        )}
        style={{ transitionProperty: 'max-height, opacity, margin' }}
        aria-hidden={!open}>
        <SummaryItem label="Discount" value={toNegative(discount)} />
        {writeOffs > 0 && <SummaryItem label="Write-offs" value={toNegative(writeOffs)} />}
        {isAEOB && (
          <SummaryItem
            label={`Insurance Adjustments${estimatedLabel}`}
            value={toNegative(insuranceAdjustments)}
          />
        )}
        {otherAdjustments > 0 && (
          <SummaryItem label="Other adjustments" value={toNegative(otherAdjustments)} />
        )}
        {insuranceBalance > 0 && (
          <SummaryItem label="Insurance Balance" value={toNegative(insuranceBalance)} />
        )}
      </div>
    </div>
  );
};

export default AdjustmentsAndDiscounts;
